export const removeCurrentYear = (dateString: string) =>
  dateString.replace(` ${new Date().getFullYear()}`, '')
